import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

export const CustomerSignaturePad = forwardRef(function CustomerSignaturePad(_props, ref) {
  const pad = useRef(null);
  useImperativeHandle(ref, () => ({
    isEmpty: () => pad.current?.isEmpty() ?? true,
    clear: () => pad.current?.clear(),
    getCanvas: () => pad.current.getCanvas(),
    getTrimmedCanvas: () => pad.current.getTrimmedCanvas(),
  }), []);

  useEffect(() => {
    const canvas = pad.current.getCanvas();
    let width = canvas.clientWidth, height = canvas.clientHeight;
    const observer = new ResizeObserver(() => {
      const nextWidth = canvas.clientWidth, nextHeight = canvas.clientHeight;
      if (!nextWidth || !nextHeight || (nextWidth === width && nextHeight === height)) return;
      const scalePoints = points => points.map(point => ({
        ...point, x: point.x * nextWidth / width, y: point.y * nextHeight / height,
      }));
      const strokes = pad.current.toData().map(group => Array.isArray(group)
        ? scalePoints(group) : { ...group, points: scalePoints(group.points || []) });
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = nextWidth * ratio;
      canvas.height = nextHeight * ratio;
      canvas.getContext("2d").scale(ratio, ratio);
      pad.current.fromData(strokes);
      width = nextWidth; height = nextHeight;
    });
    observer.observe(canvas);
    return () => observer.disconnect();
  }, []);

  return <SignatureCanvas ref={pad} penColor="#0f172a" clearOnResize={false}
    canvasProps={{ className: "block w-full h-36", style: { touchAction: "none" },
      "data-testid": "signature-pad", "aria-label": "Draw your signature" }} />;
});